import axiosInstance from "./AxiosConfig";
import endpoints from "./endpoints";

export const transactionsService = {
  getTransactionsList: () =>
    axiosInstance.get(endpoints.tokenEndPoints.allTransactions),
  getTransactionDetails: (transactionId) =>
    axiosInstance.get(`${endpoints.tokenEndPoints.transactionDetails}/${transactionId}`),
  getUserTransactions: (userId, params = {}) =>
    axiosInstance.get(`${endpoints.tokenEndPoints.userTransactions}/${userId}`, {
      params
    }),
  transactionStatusUpdate: (transactionId, statusData) =>
    axiosInstance.put(`${endpoints.tokenEndPoints.transactionStatusUpdate}/${transactionId}`, statusData),
};
